import { Link } from 'react-router-dom';
import LegalLayout from './LegalLayout';
import { OPERATOR } from './meta';

export default function Privacy() {
  return (
    <LegalLayout title="プライバシーポリシー" enacted={OPERATOR.effectiveDate}>
      <p>
        {OPERATOR.operatorName}（以下「運営者」）は、アニメーション共有サービス「
        {OPERATOR.serviceName}
        」（以下「本サービス」）における利用者の個人情報を、個人情報の保護に関する法律（以下「個人情報保護法」）その他の関係法令およびガイドラインを遵守し、以下のとおり適切に取り扱います。
      </p>

      <h2>1. 事業者の情報</h2>
      <ul>
        <li>サービス名: {OPERATOR.serviceName}</li>
        <li>運営者: {OPERATOR.operatorName}</li>
        {OPERATOR.tradeName && <li>屋号: {OPERATOR.tradeName}</li>}
        <li>
          個人情報に関する問い合わせ窓口: <Link to={OPERATOR.contactPath}>{OPERATOR.contactLabel}</Link>
        </li>
      </ul>

      <h2>2. 取得する個人情報</h2>
      <p>運営者は、本サービスの提供にあたり、次の情報を取得します。</p>
      <ul>
        <li>
          <strong>アカウント情報</strong>: メールアドレス、アカウント名（ユーザー名）、認証基盤（Amazon
          Cognito）が発行する利用者識別子。
        </li>
        <li>
          <strong>投稿に関する情報</strong>: 投稿コンテンツ（VRMA
          ファイル、サムネイル、タイトル、説明文、タグ）、公開/非公開の設定、お気に入りの登録情報。
        </li>
        <li>
          <strong>アクセス情報</strong>: IP アドレス、ブラウザ・端末情報、アクセス日時、閲覧・操作の履歴、Cookie
          等の識別子。
        </li>
        <li>
          <strong>開発者情報</strong>: 開発者登録に際して申告いただくアプリケーション名・用途・API 利用状況・発行された API キーの識別情報。
        </li>
      </ul>

      <h2>3. 利用目的</h2>
      <p>運営者は、取得した個人情報を次の目的の範囲内で利用します（個人情報保護法第17条・第21条）。</p>
      <ol>
        <li>本サービスの提供、本人確認・認証、アカウント管理のため。</li>
        <li>投稿コンテンツの保存・配信・公開範囲の制御のため。</li>
        <li>お問い合わせ・権利侵害の申告への対応のため。</li>
        <li>不正利用・規約違反の検知、防止および対応のため。</li>
        <li>本サービスの維持・改善、統計データの作成（個人を識別できない形式に加工して行います）のため。</li>
        <li>重要なお知らせや本規約・本ポリシーの変更等の通知のため。</li>
      </ol>

      <h2>4. 第三者提供</h2>
      <p>
        運営者は、個人情報保護法第27条に定める場合（本人の同意がある場合、法令に基づく場合、人の生命・身体・財産の保護に必要な場合等）を除き、あらかじめ本人の同意を得ることなく個人情報を第三者に提供しません。
      </p>
      <p>
        なお、利用者が投稿コンテンツを「公開」に設定した場合、当該コンテンツおよびそれに付随して表示されるアカウント名は、本サービスの利用者その他不特定多数の者が閲覧できる状態になります。この公開は第三者提供ではなく、利用者自身の設定に基づく公表として扱われます。
      </p>

      <h2>5. 業務の委託</h2>
      <p>
        運営者は、利用目的の達成に必要な範囲で、個人情報の取扱いをクラウドサービス事業者に委託します。運営者は、委託先に対し必要かつ適切な監督を行います。
      </p>
      <ul>
        <li>
          <strong>クラウドインフラ</strong>: Amazon Web Services, Inc. および Amazon
          Web Services Japan 合同会社（Amazon Cognito、Amazon S3、Amazon DynamoDB、Amazon
          CloudFront 等）。認証・データ保管・ファイル配信を担います。
        </li>
      </ul>

      <h2>6. 個人データの保管場所および外国での取扱い</h2>
      <ol>
        <li>
          利用者の個人データは、原則として{OPERATOR.region}に保管されます。
        </li>
        <li>
          本サービスのファイル配信には Amazon CloudFront
          を利用しており、配信の高速化のために、コンテンツが国外のエッジサーバーに一時的に複製・キャッシュされる場合があります。この限度において、個人データが外国で取り扱われることがあります。
        </li>
        <li>
          委託先である Amazon Web Services
          は、日本を含む各国の拠点を通じてサービスを提供する事業者であり、同社の情報セキュリティ・個人データ保護に関する体制は同社が公表する情報のとおりです。運営者は、外国にある第三者への提供に該当し得る場合には、個人情報保護法第28条に従って対応します。
        </li>
      </ol>

      <h2>7. 安全管理措置</h2>
      <p>
        運営者は、取り扱う個人データの漏えい、滅失または毀損の防止その他の安全管理のために、アクセス制御、通信の暗号化（HTTPS）、認証情報の適切な管理、委託先の監督等、必要かつ適切な措置を講じます。
      </p>

      <h2>8. 保有個人データの開示・訂正・利用停止等の請求</h2>
      <p>
        利用者は、個人情報保護法第32条から第39条に基づき、自己の保有個人データについて、利用目的の通知、開示、内容の訂正・追加・削除、利用停止・消去、第三者提供の停止を請求することができます。ご請求は
        <Link to={OPERATOR.contactPath}>{OPERATOR.contactLabel}</Link>
        よりご連絡ください。運営者は、ご本人からの請求であることを確認のうえ、法令に従って対応します。
      </p>

      <h2>9. Cookie 等の取扱い</h2>
      <p>
        本サービスは、ログイン状態の維持その他の機能提供のために Cookie
        および類似の技術を利用します。利用者はブラウザの設定により Cookie
        を無効化できますが、その場合、本サービスの一部機能が利用できなくなることがあります。
      </p>

      <h2>10. 未成年者の個人情報</h2>
      <p>
        未成年者が本サービスを利用し個人情報を提供する場合は、親権者その他の法定代理人の同意を得たうえで行うものとします。
      </p>

      <h2>11. 苦情・お問い合わせ窓口</h2>
      <p>
        本サービスにおける個人情報の取扱いに関する苦情・お問い合わせは、次の窓口で受け付けます。
      </p>
      <ul>
        <li>窓口: {OPERATOR.serviceName} 個人情報お問い合わせ窓口</li>
        <li>
          連絡先: <Link to={OPERATOR.contactPath}>{OPERATOR.contactLabel}</Link>
        </li>
      </ul>

      <h2>12. 本ポリシーの変更</h2>
      <p>
        運営者は、法令の改正や本サービスの内容変更に応じて本ポリシーを改定することがあります。重要な変更を行う場合は、本サービス上への掲示等の適切な方法で周知します。
      </p>

      <p className="legal__meta">制定日: {OPERATOR.effectiveDate}</p>
    </LegalLayout>
  );
}
